import React, { memo, useCallback, useState } from 'react';

interface LogoProps {
  onLogoClick: () => void;
}

const Logo: React.FC<LogoProps> = memo(({ onLogoClick }) => {
  const [imageError, setImageError] = useState(false);

  const handleClick = useCallback((e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    onLogoClick();
  }, [onLogoClick]);

  const handleKeyDown = useCallback((e: React.KeyboardEvent<HTMLAnchorElement>) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      onLogoClick();
    }
  }, [onLogoClick]);

  return (
    <a 
      href="#" 
      className="logo" 
      aria-label="חזרה לעמוד הבית" 
      onClick={handleClick}
      onKeyDown={handleKeyDown}
    >
      {!imageError ? (
        <img 
          src="https://usnhxnxfrynwiplufpcv.supabase.co/storage/v1/object/public/general_settings/images/website_logo.png"
          alt="סטודיו אנקורי" 
          className="logo-image"
          onError={(e) => {
            // Fallback to local logo if Supabase fails
            const target = e.target as HTMLImageElement;
            if (!target.src.includes('/website_logo.png')) {
              target.src = '/website_logo.png';
            } else {
              setImageError(true);
              console.error('Logo failed to load from both Supabase and local sources');
            }
          }}
        />
      ) : (
        <div className="logo-text" style={{ 
          fontSize: '24px', 
          fontWeight: 'bold', 
          color: '#333',
          fontFamily: 'inherit'
        }}>
          סטודיו אנקורי
        </div>
      )}
    </a>
  );
});

Logo.displayName = 'Logo';

export default Logo;